export const QuotationsIcon = () => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M11.8951 2.55067V4.96121C11.8943 6.1377 12.847 7.09201 14.0235 7.09526H16.3059M12.7246 3.02542C12.4027 2.68975 11.9576 2.50002 11.4921 2.50002H6.78299C5.08272 2.49353 3.68976 3.8484 3.64921 5.54786V14.3037C3.61111 16.0308 4.98056 17.4611 6.70759 17.4992C6.73272 17.5 13.3125 17.5 13.3125 17.5C15.0241 17.4302 16.3724 16.0162 16.3603 14.3037V7.49947C16.3603 7.05839 16.1892 6.63434 15.8843 6.3165L12.7246 3.02542Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.5894 9.02344H8.59159C7.99724 9.02344 7.51562 9.5051 7.51562 10.0994C7.51562 10.6937 7.99724 11.1754 8.59159 11.1754H9.82076C10.4151 11.1754 10.8967 11.6569 10.8967 12.2513C10.8967 12.8456 10.4151 13.3273 9.82076 13.3273H7.82292"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.21094 13.3277V14.2309M9.21094 8.11523V9.02657"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
